

export const GetAPI = async (apiAxios, url, options = {}) => {
    try {

        const response = await apiAxios.get(url, options);

        if (response.status === 200 || response.status === 201) {
            let retorno = response.data

            if (response.data.sucesso === "SIM") {
                retorno = response.data.data;

                // Se for string, tenta converter para objeto/array
                if (typeof retorno === "string") {
                    try {
                        retorno = JSON.parse(retorno);
                    } catch (e) {
                        retorno = [];
                    }
                }

                // Se ainda assim for nulo, força um array vazio
                if (retorno === null) {
                    retorno = [];
                }

                return {
                    success: true,
                    data: retorno,
                    errorMessage: "",
                };

            } else {

                // Se for arquivo, tenta converter para objeto/array
                if (typeof retorno === "object") {
                    return {
                        success: true,
                        data: retorno,
                        errorMessage: "",
                    };
                }

                return {
                    success: false,
                    data: null,
                    errorMessage: response.data?.data || "Erro na resposta da API.",
                };
            }
        } else {
            return {
                success: false,
                data: null,
                errorMessage: response.data?.data || "Erro inesperado.",
            };
        }
    } catch (err) {
        return {
            success: false,
            data: null,
            errorMessage: err?.response?.data?.data || "Erro na comunicação com o servidor.",
        };
    }
};
